import { HeaderBlock } from '@/legacy/blocks/Header'
import { Metatags } from '@/legacy/components/Metatags'
import { AnalyticsProvider } from '@/legacy/core/analytics'
import { BlogProvider } from '@/legacy/core/blog'

import type { AnalyticsData, BuilderBlogModel, ContentReview } from '@/legacy/models'
import { useBlogArticleCms } from '@/legacy/providers/BlogArticleCmsProvider'

interface HeaderLayoutProps {
  contentReview: ContentReview | null
  data: BuilderBlogModel
  analytics: AnalyticsData
  url: string
}

const HeaderLayout = ({ contentReview, data, url, analytics }: HeaderLayoutProps) => {
  const { appInstallBanner } = useBlogArticleCms()

  return (
    <>
      <Metatags data={data} contentReview={contentReview ?? undefined} />
      <AnalyticsProvider event={{ ...analytics, url, position: 'topo' }}>
        <BlogProvider>
          <HeaderBlock data={{ ...data, appInstallBanner }} />
        </BlogProvider>
      </AnalyticsProvider>
    </>
  )
}

export default HeaderLayout
